import { render } from "./MaintenanceView.vue?vue&type=template&id=428faf48&scoped=true"
import script from "./MaintenanceView.vue?vue&type=script&lang=js"
export * from "./MaintenanceView.vue?vue&type=script&lang=js"

import "./MaintenanceView.vue?vue&type=style&index=0&id=428faf48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428faf48"]])

export default __exports__